import { Cards } from 'app/services/responseTypes';
import api from '../..';

export const CardsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getCards: builder.query<Cards, void>({
      query: () => `/cards`,
      providesTags: () => [{ type: 'Cards', id: 'LIST' }],
    }),
    createCard: builder.mutation<any, void>({
      query: () => ({
        url: `/cards/create`,
        method: 'POST',
      }),
      invalidatesTags: [{ type: 'Card', id: 'LIST' }],
    }),
    deleteCard: builder.mutation({
      query: (id: string) => ({
        url: `/cards/destroy/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'Cards', id: 'LIST' }],
    }),
    setDefaultCard: builder.mutation({
      query: (id: string) => ({
        url: `cards/set_default/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: [{ type: 'Cards', id: 'LIST' }],
    }),
  }),
});

export const {
  useCreateCardMutation,
  useGetCardsQuery,
  useDeleteCardMutation,
  useSetDefaultCardMutation,
} = CardsApi;
